import * as React from 'react';
import debounce from 'lodash.debounce';
import { isMobile } from 'src/utils/responsiveHelpers';

import Filter from './components/Filter';
import Subcategory from './components/Subcategory';
import MobileFilterMenu from './components/MobileFilterMenu';
import MobileSubcategoriesSelect from './components/MobileSubcategoriesSelect';

import './CategoriesFilter.scss';
import SubcategoryModel from 'src/model/subcategory.model';
import { goToCategory } from 'src/utils/navigation';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';

export default class CategoriesFilter extends React.Component<
  ICategoriesFilterProps,
  ICategoriesFilterState
> {
  private resizeEvent: any;

  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile(),
      mobileMenuOpened: false
    };

    this.resizeEvent = debounce(() => {
      this.setState({ isMobile: isMobile() });
    }, 700);
  }

  private closeMobileMenu = () => {
    this.setState({ mobileMenuOpened: false });
    this.props.handleScroll(true);
  };

  private openMobileMenu = () => {
    this.setState({ mobileMenuOpened: true });
    this.props.handleScroll(false);
  };

  private cancelFilter = () => {
    this.clearFilter();
    this.closeMobileMenu();
  };

  private clearFilter = () => {
    this.props.clearFilters([]);
  };

  private selectSubcategory = (subcategoryId: number) => {
    this.clearFilter();
    setTimeout(() => {
      goToCategory(this.props.match.params.categoryId, subcategoryId);
    }, 200);
  };

  /*
			getActiveSubcategory: return the active subcategory id or object
		 */
  private getActiveSubcategory = (target: 'id' | 'object') => {
    if (target === 'id') {
      return this.props.match.params.subcategoryId;
    } else {
      return this.props.subcategories[this.props.match.params.subcategoryId];
    }
  };

  private renderSubcategories = () => {
    if (this.props.subcategories.length !== 0) {
      return this.props.subcategories
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((item: SubcategoryModel, index: number) => {
          return (
            <Subcategory
              key={index}
              active={this.props.activeSubcategory === item.id}
              action={this.selectSubcategory}
              subcategory={item}
            />
          );
        });
    } else {
      return (
        <div className="categories-filters--loading">
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
        </div>
      );
    }
  };

  private renderFilters = (t: any) => {
    if (this.props.filtersPending === false) {
      if (this.props.filters.length !== 0) {
        const { filters, activeFilters } = this.props;
        const filtersNodes = filters.map((item: any, index: number) => {
          const activeFilterIndex = activeFilters.findIndex(
            (filter: SubcategoryFilter) => {
              return filter === item;
            }
          );
          const isActive = activeFilterIndex !== -1 ? true : false;
          return (
            <Filter
              key={index}
              indexKey={index}
              active={isActive}
              filter={item}
              action={(
                subcategoryFilter: SubcategoryFilter,
                action: 'add' | 'remove'
              ) => {
                this.handleSetFilter(subcategoryFilter, action);
              }}
            />
          );
        });
        return (
          <React.Fragment>
            <p className="filter-title">{t('categories.filterBy')}:</p>
            <ul>{filtersNodes}</ul>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <p className="filter-title">{t('categories.filterBy')}:</p>
            <p className="no-filters">{t('categories.noFilters')}</p>
          </React.Fragment>
        );
      }
    } else {
      return (
        <React.Fragment>
          <p className="filter-title">{t('categories.filterBy')}:</p>
          <div className="categories-filters--loading">
            <span className="loading-item large" />
            <span className="loading-item large" />
            <span className="loading-item large" />
          </div>
        </React.Fragment>
      );
    }
  };

  private setSelectedSubcategory = () => {
    return this.props.selectedSubcategory
      ? this.props.selectedSubcategory.name.toLowerCase()
      : '';
  };

  /* handleSetFilter: Sets fiter and decides if get filtered products or no

		 */
  private handleSetFilter = (
    subcategoryFilter: SubcategoryFilter,
    action: 'add' | 'remove'
  ) => {
    this.props.setFilters(subcategoryFilter, action);
  };

  private handleSaveFilters = () => {
    if (this.state.isMobile) {
      if (this.props.activeFilters.length !== 0) {
        this.props.getFilteredProducts(
          this.props.selectedSubcategory.id.toString(),
          this.props.activeFilters
        );
      }
      this.closeMobileMenu();
    }
  };

  public componentDidMount = () => {
    window.addEventListener('resize', this.resizeEvent);
  };

  public componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeEvent);
  };

  public render() {
    const { t } = this.props;
    const mobileMenuClass = this.state.mobileMenuOpened ? 'opened' : 'closed';
    const breadcrumbCategory = this.setSelectedSubcategory().toString();

    return (
      <React.Fragment>
        <div className="categories-filters--mobile-filters no-select">
          <nav className="categories-filters---mobile-header">
            <div className="breadcrumbs">
              {`${t('common.home')} / ${t(
                'common.categories'
              )} / ${breadcrumbCategory}`}
            </div>
            <div className="filter-by" onClick={this.openMobileMenu}>
              {t('common.filterBy')}
            </div>
          </nav>
          <div>
            <MobileSubcategoriesSelect
              subcategories={this.props.subcategories}
              activeSubcategory={this.getActiveSubcategory('id')}
              isLoading={this.props.isLoadingSubcategories}
              changeSubcategory={this.selectSubcategory}
            />
          </div>
          <MobileFilterMenu
            closeMenu={this.closeMobileMenu}
            handleSaveFilters={this.handleSaveFilters}
            menuIsOpened={this.state.mobileMenuOpened}
            clear={this.clearFilter}
            cancel={this.cancelFilter}
          >
            {this.renderFilters(t)}
          </MobileFilterMenu>
        </div>

        <div className="categories-filters roboto categories-filters--desktop-filters no-select">
          <div className={`categories-filters--content ${mobileMenuClass}`}>
            <div className="filters-header">
              <i
                className="rpds-backspace back"
                onClick={this.closeMobileMenu}
              />
              <p className="text">{t('common.backToResults')}</p>
            </div>

            <div className="filters-mobile-content">
              <div className="content-nav">
                <p className="cancel" onClick={this.cancelFilter}>
                  {t('common.cancel')}
                </p>
                <p className="filter-by">{t('common.filterBy')}:</p>
                <p className="clear" onClick={this.clearFilter}>
                  {t('common.clear')}
                </p>
              </div>

              <div className="content-filters">
                <p className="filter-title">{t('categories.subcategories')}:</p>
                <div className="content-filters--subcategories">
                  {this.renderSubcategories()}
                </div>
              </div>
              <div className="content-filters">{this.renderFilters(t)}</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

interface ICategoriesFilterProps {
  handleScroll(shouldScroll: boolean): void;
  setFilters(
    subcategoryFilter: SubcategoryFilter,
    action: 'add' | 'remove'
  ): void;
  clearFilters(filters: any[]): void;
  getFilteredProducts(
    id: string,
    filters: SubcategoryFilter[],
    pageNumber?: number
  ): any;
  t: any;
  activeSubcategory: number;
  filters: SubcategoryFilter[];
  activeFilters: SubcategoryFilter[];
  filtersPending: boolean;
  match: any;
  subcategories: SubcategoryModel[];
  selectedSubcategory: SubcategoryModel;
  isLoadingSubcategories: boolean;
}

interface ICategoriesFilterState {
  isMobile: boolean;
  mobileMenuOpened: boolean;
}
